<template>
  <div
    class="progress-bar"
    :style="{ width: progressBarWidth }"
  >
    <div
      ref="progress"
      class="cl-progress-wrap"
      @click="seek"
    >
      <div
        v-for="(i, index) in percentageData"
        :key="index"
        v-tooltip="{
          content: `${i.percentage}%`,
          onShow: () => tooltip && !isMobile,
        }"
        :style="{ width: `${i.percentage}%`, height: progressBarHeight, backgroundColor: i.color }"
        class="cl-progress usn"
      >
        <div
          v-if="thumb"
          class="thumb"
        />
        <span
          v-if="displayPercentage && i.percentage >= 0 && !percentageInlinePosition"
          class="checklist-percentage-value top usn"
        >
          {{ i.percentage }}%
        </span>
      </div>
    </div>
    <span
      v-if="displayPercentage && firstElementPercentage >= 0 && percentageInlinePosition"
      class="checklist-percentage-value inline usn"
    >
      {{ firstElementPercentage }}%
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    percentageData: {
      type: Array,
      required: true,
    },
    displayPercentage: {
      type: Boolean,
      required: false,
      default: false,
    },
    percentageInlinePosition: {
      type: Boolean,
      required: false,
      default: true,
    },
    tooltip: {
      type: Boolean,
      required: false,
      default: true,
    },
    thumb: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: Number,
      required: false,
      default: 0,
    },
    height: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  emits: ['seek'],
  computed: {
    firstElementPercentage() {
      return this.percentageData[0]?.percentage;
    },

    progressBarWidth() {
      return !this.width ? '100%' : `${this.width}px`;
    },

    progressBarHeight() {
      return !this.height ? '4px' : `${this.height}px`;
    },
  },
  methods: {
    percentageIsNumber(percentage) {
      return Number.isNaN(percentage);
    },

    seek(ev) {
      const percent = (ev.offsetX / this.$refs.progress.offsetWidth) * 100;
      this.$emit('seek', percent);
    },
  },
};
</script>

<style lang="scss">
$percentageWidth: 32px;

.progress-bar {
  display: flex;
  justify-content: center;
  align-items: center;

  &.checklist-progress {
    width: calc(100% - 48px) !important;
  }

  .cl-percentage {
    font-size: 11px;
    color: #707070;
  }

  .cl-progress-wrap {
    width: 100%;
    border-radius: 4px;
    background: $primary50;
    display: flex;

    .cl-progress {
      position: relative;
      background: $stBlue;
      transition:
        width 0.3s ease-in,
        background 0.1s ease-in;

      .thumb {
        position: absolute;
        right: 0;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #ffffff;
      }

      &:first-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      &:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }

  .checklist-percentage-value {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    @apply text-text-default;

    &.top {
      position: absolute;
      top: -14px;
    }

    &.inline {
      margin-left: 12px;
    }
  }
}
</style>
